var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'h-skeleton': _vm.group === false,
    'h-skeleton-group': _vm.group === true
  }},[(_vm.group)?[_c('div',{staticClass:"h-skeleton"}),_c('div',{staticClass:"h-skeleton"}),_c('div',{staticClass:"h-skeleton sm"})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }